module.exports = __webpack_public_path__ + "img/8.d662c92b.jpg";